import cleanedFilename from '~/util/cleanedFilename';

export default {
  INPUT: `${cleanedFilename(__filename)}-input`,
  MATCH_COUNT: `${cleanedFilename(__filename)}-match-count`,
  PREVIOUS_MATCH: `${cleanedFilename(__filename)}-previous-match`,
  NEXT_MATCH: `${cleanedFilename(__filename)}-next-match`,
};
